<template>
    <div>
        <navbar></navbar>
        <section class="hero is-info is-fullheight">
        <div class="hero-body">
  <div class="container">
    <h1 class="title">
      OOPS...
    </h1>
    <h2 class="subtitle">
      Something went horribly wrong. Please contact us to resolve.
    </h2>
    <div class="boxer">
                     </div>
  </div>
</div>
</section>

        </div>
    </div>
</template>

<script>
import Navbar from "./features/Navbar"


export default {
    name: 'Oops',
    data() {
        return {
			search: '',
			desc: '',
            books: []
        }
    },
    components: {
        Navbar,
    },
    mounted() {
    },
    methods: {

	},
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
.grey-background {
    background-color: hsl(0, 0%, 86%) !important;
}

.hero.is-info {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('../assets/images/oops-image.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Oops.vue